import React, { useState } from "react";

type DragProps = {
  draggable?: boolean;
  onDragStart?: (event: React.DragEvent) => void;
  onDragOver?: (event: React.DragEvent) => void;
  onDragLeave?: () => void;
  onDrop?: (event: React.DragEvent) => void;
  onDragEnd?: () => void;
};

/** Dragging columns by their header, using HTML5 drag and drop. */
export const useColumnDrag = (
  onReorder: (key: string, target: string) => void,
) => {
  const [dragKey, setDragKey] = useState<string | null>(null);
  const [overKey, setOverKey] = useState<string | null>(null);

  const dragProps = (key: string): DragProps => ({
    draggable: true,
    onDragStart: (event) => {
      setDragKey(key);
      event.dataTransfer.effectAllowed = "move";
      // Firefox does not start a drag without data in the clipboard.
      event.dataTransfer.setData("text/plain", key);
    },
    onDragOver: (event) => {
      if (!dragKey || dragKey === key) return;
      event.preventDefault();
      event.dataTransfer.dropEffect = "move";
      setOverKey(key);
    },
    onDragLeave: () => setOverKey((prev) => (prev === key ? null : prev)),
    onDrop: (event) => {
      event.preventDefault();
      if (dragKey && dragKey !== key) onReorder(dragKey, key);
      setDragKey(null);
      setOverKey(null);
    },
    onDragEnd: () => {
      setDragKey(null);
      setOverKey(null);
    },
  });

  return { dragProps, dragKey, overKey };
};

export default useColumnDrag;
